<template>
  <div>
    <div class="order__lists-wrapper" v-if="lists">
      <div class="order-list__item" v-for="(list, index) in lists" :key="index">
        <div class="item__wrapper">
          <div class="item__order-base-info">
            <div class="item__cover">
              <img :src="list.title_picture_url | parseImage" alt="" />
            </div>
            <div class="item__order-info">
              <div class="order-info__main-body">
                <div class="main-body__child">
                  <div class="child__text child__order-name">
                    <span class="__name">{{ list.sample_name }}</span
                    ><span class="__counts">1块</span>
                  </div>
                  <p class="child__text">发 货 人：{{ list.store_name }}</p>
                  <p class="child__text">联系电话：{{ list.phone }}</p>
                  <p class="child__text">发货地址：{{ list.address }}</p>
                  <div class="child__bt --more-info" @click="showMore(list.id)">
                    {{ currentActive && Number(currentActive.oid) === list.id ? "-" : "+" }}更多信息
                  </div>
                </div>
                <div class="main-body__child">
                  <p class="child__text">
                    <span class="__status">{{ orderType === 1 ? "等发货" : "" }}</span>
                  </p>
                  <p class="child__text child__order-total">
                    <span class="__total">订单总计 ¥{{ list.money }}.00 </span>
                  </p>
                  <el-button
                    class="child__bt --submit"
                    v-if="orderType === 2 && list.is_received === 1"
                    :loading="currentReceiveId === list.id"
                    @click="onReceived(list.id)"
                  >
                    确认收货
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="item__order-more-info"
            ref="item__order-more-info"
            :data-oid="list.id"
            :style="{
              height:
                currentActive && Number(currentActive.oid) === list.id
                  ? `${currentActive.height}px`
                  : '0px'
            }"
          >
            <div class="order-more-info__main-body">
              <div class="main-body__text">
                <p>订单编号：{{ list.orderNum }}</p>
                <p v-if="list.express_ordernum">物流号：{{ list.express_ordernum }}</p>
                <p>付款时间：{{ list.ctime | parseTime("{y}-{m}-{d} {n}{h}:{i}") }}</p>
                <p v-if="list.delivery_time > 0">
                  发货时间：{{ list.delivery_time | parseTime("{y}-{m}-{d} {n}{h}:{i}") }}
                </p>
              </div>
              <div
                class="main-body__bt --copy"
                @click="
                  onCopy({
                    orderNum: list.orderNum,
                    expressOrdernum: list.express_ordernum
                  })
                "
              >
                复制
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <empty hint="没有找到相关信息" v-else></empty>
    <pagination
      :config="isShowPagination"
      v-if="isShowPagination && lists > 0"
      class="component-pagination"
    ></pagination>
  </div>
</template>

<script>
import Pagination from '@/components/pagination.vue';
import Empty from '@/pages/common/empty.vue';

export default {
  components: {
    Pagination,
    Empty,
  },
  props: {
    orders: {
      type: Array,
      default: undefined,
    },
    isShowPagination: {
      type: Object,
      default: undefined,
    },
    orderType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: undefined,
      cover: '/static/images/order/1.jpg',
      infoHeight: new Map(),
      currentActive: null,
      currentReceiveId: 0,
    };
  },
  watch: {
    orders(val) {
      this.lists = val && val.length > 0 ? val : undefined;
    },
  },
  created() {},
  updated() {
    this.$nextTick(() => {
      if (this.$refs['item__order-more-info']) {
        this.$refs['item__order-more-info'].forEach((item) => {
          this.infoHeight.set(
            Number(item.dataset.oid),
            item.querySelector('.order-more-info__main-body').offsetHeight,
          );
        });
      }
    });
  },
  mounted() {},
  methods: {
    showMore(oid) {
      const height = this.infoHeight.get(oid);
      if (this.currentActive && this.currentActive.oid === oid) {
        this.currentActive = null;
      } else {
        this.currentActive = {
          oid,
          height,
        };
      }
    },
    onCopy(data) {
      const str = `订单号：${data.orderNum}${
        data.expressOrdernum ? `，物流号${data.expressOrdernum}` : ''
      }`;
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', str);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        alert('链接复制成功！');
      } else {
        alert('复制失败！请手动复制！');
      }
      document.body.removeChild(input);
    },
    onReceived(oid) {
      this.currentReceiveId = oid;
      this.$http
        .post('html/user/received', {
          id: oid,
        })
        .then(() => {
          this.lists = this.lists.map((item) => {
            const temp = item;
            temp.is_received = oid === item.id ? 2 : temp.is_received;
            return temp;
          });
        })
        .finally(() => {
          this.currentReceiveId = 0;
        });
    },
  },
};
</script>

<style></style>
